@if (notifications().length) {
  <div class="ccf-notification-stack d-flex flex-column gap-3 pe-none">
    @for (notification of notifications(); track notification.id) {
      <app-ccf-notification
        class="pe-auto"
        [message]="notification.message ?? (notification.messageKey | translate: notification.params)"
        [state]="notification.state"
        [role]="notification.state === 'error' ? 'alert' : 'status'"
        layout="popup"
        [dismissible]="true"
        (dismissed)="dismiss(notification.id)" />
    }
  </div>
}
